export const SET_RESPONSE_STATUS = 'SET_RESPONSE_STATUS'
export const CLEAR_RESPONSE_STATUS = 'CLEAR_RESPONSE_STATUS'
export const SET_SELLERS_LIST = 'SET_SELLERS_LIST'
